import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseEntityService } from '../base-entity.service';
import { ContentSectionStore } from './content-section.store';
import { DefaultResponse } from '../session';
import { Observable, map, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PublicContentSection } from '../../../../../../api/src/content-section/content-section.entity';
import { ContentSectionAddDto } from '../../../../../../api/src/content-section/dtos/content-section-add.dto';
import { ContentSectionUpdateDto } from '../../../../../../api/src/content-section/dtos/content-section-update.dto';

@Injectable({ providedIn: 'root' })
export class ContentSectionService extends BaseEntityService {
	constructor(private http: HttpClient, private contentSectionStore: ContentSectionStore) {
		super();
	}

	reset() {
		this.contentSectionStore.set([]);
	}

	find(usageContext?: string): Observable<DefaultResponse<PublicContentSection>> {
		let body = {};

		if (usageContext) {
			body = { usageContext };
		}

		this.reset();

		return this.http.post<DefaultResponse<any>>(`${environment.apiUrl}/content-section/find`, body).pipe(
			tap(response => {
				this.contentSectionStore.set(response.data?.results);
			})
		);
	}

	get({ page = 1, limit = 10, sort }): Observable<DefaultResponse<PublicContentSection>> {
		this.reset();

		return this.http
			.post<DefaultResponse<any>>(
				`${environment.apiUrl}/content-section/find`,
				{},
				{ params: { page, perPage: limit, sortBy: sort.sortBy, order: sort.direction } }
			)
			.pipe(
				map(response => ({
					totalResults: response.data.totalResults,
					data: response.data?.results,
					status: response.status,
					message: response.message,
					numPages: response.data.numPages,
					perPage: response.data.perPage,
					page: response.data.page
				})),
				tap(response => {
					console.log('response.data', response.data);
					this.contentSectionStore.set(response.data);
				})
			);
	}

	public create(contentSectionAddDto: ContentSectionAddDto): Observable<DefaultResponse<PublicContentSection>> {
		return this.http.post<DefaultResponse<PublicContentSection>>(`${environment.apiUrl}/content-section`, contentSectionAddDto).pipe(
			tap(res => {
				if (res.status === 'succeeded') {
					this.contentSectionStore.upsert(res.data.id, res.data);
				}
			})
		);
	}

	public update(
		contentSectionId: string,
		contentSectionUpdateDto: ContentSectionUpdateDto
	): Observable<DefaultResponse<PublicContentSection>> {
		return this.http
			.put<DefaultResponse<PublicContentSection>>(
				`${environment.apiUrl}/content-section/${contentSectionId}`,
				contentSectionUpdateDto
			)
			.pipe(
				tap(res => {
					if (res.status === 'succeeded') {
						this.contentSectionStore.upsert(res.data.id, res.data);
					}
				})
			);
	}

	public delete(contentSectionSlug: string): Observable<DefaultResponse<PublicContentSection>> {
		return this.http.delete<DefaultResponse<PublicContentSection>>(`${environment.apiUrl}/content-section/${contentSectionSlug}`).pipe(
			tap(res => {
				if (res.status === 'succeeded') {
					this.contentSectionStore.remove(contentSectionSlug);
				}
			})
		);
	}
}
